{
  "version": 1,
  "asset_id": "51b69788-cba3-493d-9535-c4e517fa3dc5",
  "project_id": "e3708065-dee2-4f65-a2de-1d1b02caf785",
  "url": "/__l5e/assets-v1/51b69788-cba3-493d-9535-c4e517fa3dc5/buddha-ka-official.png",
  "r2_key": "a/v1/e3708065-dee2-4f65-a2de-1d1b02caf785/51b69788-cba3-493d-9535-c4e517fa3dc5/buddha-ka-official.png",
  "original_filename": "buddha-ka-official.png",
  "size": 2583200,
  "content_type": "image/png",
  "created_at": "2026-07-15T00:13:26Z"
}
